// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MnYK","col":"styles_col__2p7pP"};